import React, { Component } from 'react';
import { Image, Button } from 'semantic-ui-react'
import './Unauthorized.css';
import alert from '../img/Alert.PNG';
import DualHeader from './DualHeader.js';
import DualFooter from './DualFooter.js';

class Unauthorized extends Component {

    constructor(props) {
        super(props)
        this.handleGoToHelp = this.handleGoToHelp.bind(this);
    }
    componentDidMount() {
        // This method is called when the component is first added to the document
        //this.ensureDataFetched();
    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        //this.ensureDataFetched();
    }

    ensureDataFetched() {
        const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
        this.props.requestWeatherForecasts(startDateIndex);
    }

    handleGoToHelp() {
        this.props.history.push('./help');
    }

    render() {
        return (
            <div className='outer-container'>
                <div className='inner-container'>
                    <DualHeader/>
                    <div>
                 
                        <div className="textdiv">
                            <Image src={alert} className="alertimg" />
                            <h2>English</h2>
                            <p className="unauthtext">
                                Thank you for visiting the Computer Upgrade Registration Website. <br />
                                Currently, you do not have access to this site.<br />Access is determined by upgrade eligibility.<br />
                                <br />Please click the help button below if you believe this message is in error.
                            </p>
                            <h2>Deutsch</h2>
                            <p className='unauthtext'>
                                Vielen Dank für deinen Besuch auf der Website zur Registrierung für Computer-Upgrades.<br />
                                Derzeit hast du keinen Zugriff auf diese Website. <br />
                                Der Zugriff hängt von deiner Upgrade-Berechtigung ab.<br />
                                <br />Wenn Sie der Meinung sind, dass diese Meldung fehlerhaft ist, klicken Sie bitte auf die Schaltfläche 'Help' unten.
                            </p>
                            <h2>Français</h2>
                            <p className='unauthtext'>
                                Merci d'avoir visité le site Web d'enregistrement pour la mise à jour informatique. <br />
                                Actuellement, vous n'avez pas d'accès à ce site.<br />L'accès est déterminé par l'éligibilité à la mise à jour.<br />
                                <br />Veuillez cliquer sur le bouton 'Help' ci-dessous si vous pensez que ce message est erroné.
                            </p>
                            <Button className="helpbuttonunauth" onClick={this.handleGoToHelp}>Help</Button>
                        </div>
                    </div>
                </div>
                <DualFooter/>
            </div>
        );
    }
}


export default Unauthorized;
